"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
const SellerServiceUtil_1 = require("./SellerServiceUtil");
const defaultConfig = {
    baseUrl: process.env.SELLER_SERVICE_URL,
    user: process.env.SELLER_BASIC_AUTH_USER,
    password: process.env.SELLER_BASIC_AUTH_PASSWORD,
};
class AccountClient extends base_client_1.ApiBasicAuthClient {
    constructor(config = defaultConfig) {
        super({
            baseURL: `${config.baseUrl}/v1`,
            basicAuthPassword: config.password,
            basicAuthUser: config.user,
        });
        if (!config.user || !config.password) {
            commons_logs_1.log.warn("SELLER_BASIC_AUTH_USER and SELLER_BASIC_AUTH_PASSWORD environment variable is not set");
        }
    }
    async createAccount(request) {
        try {
            return await this.post("/account", request);
        }
        catch (error) {
            (0, SellerServiceUtil_1.handleSellerServiceError)("createAccount", error);
        }
    }
    async getSellerId(accountId) {
        try {
            return await this.get(`/account/${accountId}/sellerId`);
        }
        catch (err) {
            (0, SellerServiceUtil_1.handleSellerServiceError)("getSellerId", err);
        }
    }
}
exports.AccountClient = AccountClient;
//# sourceMappingURL=AccountClient.js.map